module.exports = __webpack_public_path__ + "efd0414b1ce2279c23526c50703ffe81.png";